import { Field, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { Types } from 'mongoose'
import { BaseEntity, Contact } from '@ztechapps/common.contract'

@ObjectType()
export class Hauler extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: Types.ObjectId, required: true, default: () => new Types.ObjectId() })
  declare _id: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  contactFirstName?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  contactLastName?: string

  @Field(() => Contact, { nullable: true })
  @Prop({ type: Contact })
  contact?: ReturnType<() => Contact>
}
